import { NavigationMenu as BaseNavigationMenu } from "@base-ui-components/react/navigation-menu";
import { navigationMenuContentClasses } from "./NavigationMenu.style";
import { NavigationMenuContentProvider } from "./NavigationMenuLink";

type NavigationMenuContentProps = BaseNavigationMenu.Content.Props;

const NavigationMenuContent = (props: NavigationMenuContentProps) => {
  const { children, className, ...rest } = props;
  const resolvedClassName =
    typeof className === "function"
      ? className({
          open: false,
          transitionStatus: "idle",
          activationDirection: null,
        })
      : className;
  return (
    <BaseNavigationMenu.Content
      className={navigationMenuContentClasses({ className: resolvedClassName })}
      {...rest}
    >
      <NavigationMenuContentProvider value={true}>
        {children}
      </NavigationMenuContentProvider>
    </BaseNavigationMenu.Content>
  );
};

export default NavigationMenuContent;
